'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

var _alert = require('../../alert');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertSuccess = function AlertSuccess(_ref) {
  var handleDismiss = _ref.handleDismiss,
      children = _ref.children;
  return _react2.default.createElement(
    _alert2.default,
    {
      className: 'alert-success cp-alert-success',
      renderIcon: function renderIcon() {
        return _react2.default.createElement(_baseIcons.CheckmarkCircle, null);
      },
      handleDismiss: handleDismiss },
    children
  );
};

AlertSuccess.propTypes = {
  handleDismiss: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

exports.default = AlertSuccess;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/success/components/AlertSuccess.component.js
// module id = 1022
// module chunks = 1